import { ApplicationEnum, DriveEventActionEnum, DriveEventSubActionEnum } from '@workalizer/shared';
import { format } from 'date-fns';
var demoEvents = function () {
    var baseDate = '2024-01-15';
    return [
        {
            id: 101,
            type: ApplicationEnum.DRIVE,
            action: DriveEventActionEnum.DOCUMENT_CREATE,
            subAction: null,
            title: 'Created by Anna Kowalska',
            startDate: "".concat(baseDate, "T08:20:00.000Z"),
            endDate: null,
            orgUnitTitle: 'Finance',
            users: [
                {
                    id: 1,
                    name: 'Anna Kowalska',
                    email: 'anna@example.com',
                    avatar: null
                }
            ]
        },
        {
            id: 102,
            type: ApplicationEnum.DRIVE,
            action: DriveEventActionEnum.DOCUMENT_PRINT,
            subAction: null,
            title: 'Print by Piotr Zielinski',
            startDate: "".concat(baseDate, "T08:48:00.000Z"),
            endDate: null,
            orgUnitTitle: 'Ops',
            users: [
                {
                    id: 2,
                    name: 'Piotr Zielinski',
                    email: 'piotr@example.com',
                    avatar: null
                }
            ]
        },
        {
            id: 103,
            type: ApplicationEnum.DRIVE,
            action: DriveEventActionEnum.DOCUMENT_APPROVAL_REQUESTED,
            subAction: null,
            title: 'Approval Requested by Ewa Wisniewska',
            startDate: "".concat(baseDate, "T09:03:00.000Z"),
            endDate: null,
            orgUnitTitle: 'HR',
            users: [
                {
                    id: 3,
                    name: 'Ewa Wisniewska',
                    email: 'ewa@example.com',
                    avatar: null
                }
            ]
        },
        {
            id: 104,
            type: ApplicationEnum.DRIVE,
            action: DriveEventActionEnum.DOCUMENT_CREATE_SUGGESTION,
            subAction: null,
            title: 'Suggestion by Michael Brown',
            startDate: "".concat(baseDate, "T09:10:00.000Z"),
            endDate: null,
            orgUnitTitle: 'Legal',
            users: [
                {
                    id: 4,
                    name: 'Michael Brown',
                    email: 'michael@example.com',
                    avatar: null
                }
            ]
        },
        {
            id: 105,
            type: ApplicationEnum.DRIVE,
            action: DriveEventActionEnum.DOCUMENT_CREATE_COMMENT,
            subAction: null,
            title: 'Comment by Anna Kowalska',
            startDate: "".concat(baseDate, "T09:15:00.000Z"),
            endDate: null,
            orgUnitTitle: 'Finance',
            users: [
                {
                    id: 1,
                    name: 'Anna Kowalska',
                    email: 'anna@example.com',
                    avatar: null
                }
            ]
        },
        {
            id: 106,
            type: ApplicationEnum.DRIVE,
            action: DriveEventActionEnum.DOCUMENT_RESOLVE_COMMENT,
            subAction: null,
            title: 'Comment resolved by John Smith',
            startDate: "".concat(baseDate, "T09:30:00.000Z"),
            endDate: null,
            orgUnitTitle: 'Product',
            users: [
                {
                    id: 5,
                    name: 'John Smith',
                    email: 'john@example.com',
                    avatar: null
                }
            ]
        },
        {
            id: 107,
            type: ApplicationEnum.DRIVE,
            action: DriveEventActionEnum.DOCUMENT_SHARE,
            subAction: DriveEventSubActionEnum.DOCUMENT_SHARED_INTERNALLY,
            title: 'Shared Internally by Anna Kowalska',
            startDate: "".concat(baseDate, "T09:55:00.000Z"),
            endDate: null,
            orgUnitTitle: 'Finance',
            users: [
                {
                    id: 1,
                    name: 'Anna Kowalska',
                    email: 'anna@example.com',
                    avatar: null
                }
            ]
        }
    ];
};
export var documentEventsLog = function (input) {
    var dateFrom = format(new Date(input.dateFrom), 'yyyy-MM-dd');
    var dateTo = format(new Date(input.dateTo), 'yyyy-MM-dd');
    var items = demoEvents().filter(function (item) {
        var _a;
        var eventDate = item.startDate.slice(0, 10);
        if (eventDate < dateFrom || eventDate > dateTo) {
            return false;
        }
        if (input.userId != null) {
            var user = (_a = item.users) === null || _a === void 0 ? void 0 : _a[0];
            if (!user || user.id !== input.userId) {
                return false;
            }
        }
        if (input.action && item.action !== input.action) {
            return false;
        }
        if (input.subAction && item.subAction !== input.subAction) {
            return false;
        }
        return true;
    });
    return { items: items };
};
